let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("hrf1M")).then(() => parcelRequire('3QCDD'));